import { createBrowserHistory } from 'history'

const historyInstance = createBrowserHistory()
console.debug("History instance has been created: ", historyInstance)

export default historyInstance